const PHRASES = [
  "Redevelopment",
  "Plotted Land Development",
  "from Earth to Extraordinary",
  "Long-Term Value",
  "Responsible Development",
  "Where Land Meets Vision",
];

const Marquee = () => (
  <div className="overflow-hidden border-y border-ink/10 bg-sand py-6" aria-hidden="true" data-testid="brand-marquee">
    <div className="marquee-track flex w-max items-center">
      {[...PHRASES, ...PHRASES].map((phrase, i) => (
        <span key={i} className="flex items-center whitespace-nowrap">
          <span className="px-8 font-display text-2xl italic text-ink/70 md:text-3xl">{phrase}</span>
          <span className="h-1.5 w-1.5 rotate-45 bg-brand" />
        </span>
      ))}
    </div>
  </div>
);

export default Marquee;
